import React, { useState, CSSProperties } from 'react'

import { useCSVReader } from 'react-papaparse'
import { Button } from '@demandlocal/components'
import { ReactComponent as Upload } from './../images/icons/upload.svg'

type Props = {
  onFileAccepted: (results: { data: Array<Record<string, unknown>> }, file: File) => void
}

export default function CSVReader(props: Props): JSX.Element {
  const { onFileAccepted } = props
  const { CSVReader } = useCSVReader()

  return (
    <CSVReader
      onUploadAccepted={(
        results: { data: Array<Record<string, unknown>> },
        file: File,
      ) => {
        if (results.data.length > 0) {
          const _data = results?.data
            .slice(0, 200)
            .map((d: Record<string, unknown>, index: number) => {
              return { ...d, id: index }
            })

          onFileAccepted({ ...results, data: _data }, file)
        }
      }}
      onDragOver={(event: DragEvent) => {
        event.preventDefault()
      }}
      onDragLeave={(event: DragEvent) => {
        event.preventDefault()
      }}
      config={{
        header: true,
        dynamicTyping: true,
        skipEmptyLines: 'greedy',
      }}>
      {({ getRootProps }) => (
        <div
          className={
            'font-Spartan font-medium align-center border-[3px] border-dashed border-silver radius-[10px] flex flex-column justify-center p-5 h-full w-full hover:border-[#686868]'
          }
          {...getRootProps()}>
          <div className={'flex flex-col items-center'}>
            <Upload />
            <div className={'py-2'}>Drag and drop files here</div>
            <Button type={'button'} variant={'secondary'}>
              Upload
            </Button>
          </div>
        </div>
      )}
    </CSVReader>
  )
}
